/* Add gift product to cart */

function getCartApiPath(suffix) {
    const root = window.routes?.root_url || window.Shopify?.routes?.root || '';
    const cartBase = (root === '/' || root === '')
        ? '/cart'
        : `${String(root).replace(/\/$/, '')}/cart`;

    if (suffix.startsWith('?') || suffix.includes('=')) {
        const query = suffix.startsWith('?') ? suffix : `?${suffix}`;
        return `${cartBase}${query}`;
    }

    return `${cartBase}/${suffix}`;
}

window.addGiftProduct = async function(gift_data) {
    var productData = {
        'items': gift_data
    };
    var result = await fetch(getCartApiPath('add.js'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productData)
    })

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Remove gift product from cart */

window.removeGiftProduct = async function(gift_data) {
    gift_data = Object.assign({}, gift_data);

    var productData = {updates: gift_data};

    var result = await fetch(getCartApiPath('update.js'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productData)
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Clear cart */

window.clearCart = async function() {
    var result = await fetch(getCartApiPath('clear.js'), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}
window.getCart = async function () {
    var result = await fetch(getCartApiPath('view=cartJson'), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    if(result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* ===== SpeedSense: shared cart mutation helpers (WANG.J 2026-08-06) ===== */

function buildCartItemsData(cartData) {
    const data = {
        productData: [],
        giftsInCart: [],
        cartTotal: 0,
    };

    const exchangeRate = parseFloat(window.Shopify.currency.rate);
    const excludeSellingPlanNames = window.promotionSettings.excludeSellingPlanNames?window.promotionSettings.excludeSellingPlanNames.split(","):[]
    const customerGroupConfigs = [
        window.freeShipping?.shipping?.[0]?.newCustomerGroupA,
        window.freeShipping?.shipping?.[0]?.newCustomerGroupB
    ].filter(Boolean);
    const customerGroupGiftProductIds = customerGroupConfigs
        .map((groupConfig) => groupConfig.sellingGiftProductId)
        .filter((productId) => productId != null && productId !== '')
        .map((productId) => String(productId));

    let total_price = cartData.total_price;

    cartData['items'].forEach(function (item) {
        const giftSource = item.properties && item.properties._source;
        const isCustomerGroupGift =
            // Legacy deployments wrote group-specific source markers; current claims use cart-claim plus product id.
            giftSource === 'new-customer-group-a' ||
            giftSource === 'new-customer-group-b' ||
            (giftSource === 'cart-claim' &&
                customerGroupGiftProductIds.includes(String(item.product_id)));
        const hasSellingPlan = Boolean(
            item.selling_plan &&
            excludeSellingPlanNames.some((selling_item) => item.selling_plan.name.includes(selling_item))
        );
        if (hasSellingPlan || isCustomerGroupGift) {
            total_price = total_price - item.line_price;
        }
        if((item.product_type || '').toLowerCase() !== 'gwp' && !isCustomerGroupGift) {
            data.productData.push({
                id: item.id,
                productID: item.product_id.toString(),
                quantity: item.quantity,
                price: (item.line_price / 100),
            })
        } else {
            data.giftsInCart.push(item.id)
        }
    });
    // Convert cart total to USD before comparison
    data.cartTotal = (total_price / 100) / exchangeRate;
    return data;
}

/* GWP threshold add/remove — ported from window.promotionValidate */
window.computeGwpMutations = function (cartData) {
    const gwpList = (window.promotionSettings && window.promotionSettings.gwp) || [];
    const giftToAdd = [];
    const giftToRemove = {};
    let conditionArray = [];
    const cartItemsData = buildCartItemsData(cartData);

    if (cartItemsData.productData.length > 0 || cartItemsData.giftsInCart.length > 0) {
        gwpList.forEach((promotion) => {
            if (promotion.minimumCartAmount != false) {
                conditionArray.push('minimumCartAmount');
            }

            // Compare USD cart total with USD threshold
            if (promotion.minimumCartAmount &&
                promotion.giftInventory > promotion.minimumGiftQuantity &&
                cartItemsData.cartTotal >= parseInt(promotion.minimumCartAmount) &&
                !promotion.conditionArray.includes('minimumCartAmount')) {
                promotion.conditionArray.push('minimumCartAmount');
            }

            /* Compare both arrays (all options in cart and fulfilled option) */
            if (conditionArray.length == promotion.conditionArray.length) {
                promotion.isCriteriaMeet = true;
            }
            if (promotion.isCriteriaMeet) {
                if (promotion.enable && promotion.available && !cartItemsData.giftsInCart.includes(promotion.varID)) {
                    giftToAdd.push({ id: promotion.varID, quantity: 1 });
                }
            } else {
                if (promotion.enable && cartItemsData.giftsInCart.includes(promotion.varID)) {
                    giftToRemove[promotion.varID] = 0;
                }
            }
            conditionArray = [];
            promotion.isCriteriaMeet = false;
            promotion.conditionArray = [];
        });
    }

    return { add: giftToAdd, remove: giftToRemove };
};

/* Empty-cart GWP cleanup — ported from CartNotification.validateGWPProducts */
window.computeGwpClearMutations = function (cartData) {
    const remove = {};
    if (!cartData || !Array.isArray(cartData.items)) {
        return { add: [], remove };
    }
    const isGwp = (item) => (item.product_type || '').toLowerCase() === 'gwp';
    const gwpItems = cartData.items.filter(isGwp);
    const nonGwpItems = cartData.items.filter(item => !isGwp(item));
    if (gwpItems.length > 0 && nonGwpItems.length === 0) {
        gwpItems.forEach(item => {
            remove[item.id] = 0;
        });
    }
    return { add: [], remove };
};

/* PMO Buy X Get Y — ported from window.pmoBuyXgetY */
window.computePmoMutations = function (cartData) {
    const pmo = window.pmoBuyXgetYSettings;
    const pmoEnable = pmo.enable;
    const productData = [];
    const productDataRemove = {};
    const pmoProductx = pmo.pmoProduct;
    const pmoProductxFree = pmo.pmoFreeProduct;
    const excludeSellingPlanNames = pmo.excludeSellingPlanNames ? pmo.excludeSellingPlanNames.split(",") : [];

    if (pmoEnable && cartData && Array.isArray(cartData.items)) {
        for (let index = 0; index < pmoProductx.length; index++) {
            const pmoProductx_item = pmoProductx[index];
            // Skip slots that Liquid left empty (product blank or promo disabled)
            if (!pmoProductx_item || !pmoProductx_item.productId || !pmoProductxFree[index] || !pmoProductxFree[index].varID || pmoProductxFree[index].varID === 'xxx') continue;
            const excludedVariantIDs = pmoProductx[index].excludedVariantIDs;

            const checkProductxVariantID = (variantID) => {
                let variantIDArray = excludedVariantIDs.split(",");
                return variantIDArray.some(id => id == variantID);
            };

            const cartItem = cartData.items.filter(item => {
                let hasSellingPlan = false;
                excludeSellingPlanNames.forEach(selling_item => {
                    if (item.selling_plan && item.selling_plan.name.includes(selling_item)) {
                        hasSellingPlan = true;
                    }
                });
                return !hasSellingPlan;
            });
            const qualifiedXProduct = cartItem.filter(item => (item.product_id == pmoProductx[index].productId && !checkProductxVariantID(item.variant_id)));
            const ispmoProductx = cartItem.filter(item => item.product_id == pmoProductx[index].productId).length > 0;
            const ispmoProductxFree = cartItem.filter(item => item.id == pmoProductxFree[index].varID).length > 0;
            const pmoProductVariantIDs = pmoProductx[index].listVariantID;

            // check the cart if the Product X exists
            let removeFreeProduct = cartItem.filter(product => {
                const variantID = product.variant_id;
                return pmoProductVariantIDs.includes(product.id) && !checkProductxVariantID(variantID);
            }).length > 0 ? false : true;

            // Check if qualified product x is in cart, if yes add free product
            let addFreeProduct = (excludedVariantIDs === "" || (excludedVariantIDs != "" && qualifiedXProduct.length > 0));

            if (!ispmoProductxFree && ispmoProductx && pmoProductxFree[index].available && addFreeProduct) {
                productData.push({ id: pmoProductxFree[index].varID, quantity: 1 });
            }

            if (ispmoProductxFree && pmoProductxFree[index].available && removeFreeProduct) {
                productDataRemove[pmoProductxFree[index].varID] = 0;
            }
        }
    } else if (!pmoEnable && cartData && Array.isArray(cartData.items)) {
        const cartVariantIds = new Set(cartData.items.map(item => String(item.id)));

        // GWP owns pmoFreeProduct2, so only remove PMO-specific gifts here.
        (pmoProductxFree || []).forEach((entry) => {
            if (!entry || !entry.available || !entry.varID || entry.varID === 'xxx') return;
            if (!cartVariantIds.has(String(entry.varID))) return;
            productDataRemove[entry.varID] = 0;
        });
    }

    return { add: productData, remove: productDataRemove };
};

window.mergeMutations = function (...plans) {
    const add = [];
    const seen = new Set();
    const remove = {};
    plans.forEach(plan => {
        (plan.add || []).forEach(item => {
            const key = String(item.id);
            if (!seen.has(key)) {
                seen.add(key);
                add.push(item);
            }
        });
        Object.assign(remove, plan.remove || {});
    });
    // Removals win over additions for the same id
    const removeKeys = new Set(Object.keys(remove).map(String));
    return { add: add.filter(item => !removeKeys.has(String(item.id))), remove };
};

window.isEmptyMutations = function (plan) {
    return (!plan.add || plan.add.length === 0) && (!plan.remove || Object.keys(plan.remove).length === 0);
};

window.applyMutations = async function (plan) {
    const removeKeys = plan.remove ? Object.keys(plan.remove) : [];
    if (removeKeys.length > 0) {
        await window.removeGiftProduct(plan.remove);
    }
    if (plan.add && plan.add.length > 0) {
        await window.addGiftProduct(plan.add);
    }
};

window.__cartSyncQueue = window.__cartSyncQueue || Promise.resolve();

window.runCartSync = async function () {
    const result = window.__cartSyncQueue.then(async () => {
        const snapshot = await window.getCart();
        if (!snapshot || !Array.isArray(snapshot.items) || snapshot.items.length === 0) {
            return snapshot;
        }

        let plan = window.mergeMutations(
            window.computePmoMutations(snapshot),
            window.computeGwpMutations(snapshot),
            window.computeGwpClearMutations(snapshot)
        );

        let latest = snapshot;
        for (let round = 0; round < 2; round++) {
            if (window.isEmptyMutations(plan)) return latest;
            await window.applyMutations(plan);
            const fresh = await window.getCart();
            latest = fresh;
            const next = window.mergeMutations(
                window.computePmoMutations(fresh),
                window.computeGwpMutations(fresh),
                window.computeGwpClearMutations(fresh)
            );
            if (window.isEmptyMutations(next) ||
                (JSON.stringify(plan.add || []) === JSON.stringify(next.add || []) &&
                    JSON.stringify(plan.remove || {}) === JSON.stringify(next.remove || {}))) {
                return fresh;
            }
            plan = next;
        }

        return latest;
    });
    window.__cartSyncQueue = result.catch(() => {});
    return result;
};

/* Backward-compatible wrappers — can still be called directly */

window.promotionValidate = async function (cartData) {
    if (!cartData) {
        cartData = await window.getCart();
    }
    if (cartData) {
        window.cartItemsData = buildCartItemsData(cartData);
        const plan = window.mergeMutations(
            window.computeGwpMutations(cartData),
            window.computeGwpClearMutations(cartData)
        );
        await window.applyMutations(plan);
    }
};

window.pmoBuyXgetY = async function (param = null) {
    let cartData = (param && typeof param === 'object') ? param : null;
    if (!cartData) {
        cartData = await window.getCart();
    }
    if (cartData) {
        const plan = window.computePmoMutations(cartData);
        await window.applyMutations(plan);
    }
    if (param === 'reload') {
        window.location.reload();
    }
};
